// user
export const SET_USER = 'user/SET_USER'
export const SET_USER_NAME = 'user/SET_USER_NAME'
export const SET_USER_MOBILE = 'user/SET_USER_MOBILE'
export const SET_PAYMENT_PASSWORD_STATUS = 'user/SET_PAYMENT_PASSWORD_STATUS'
export const CLEAN_USER = 'user/CLEAN_USER'
export const SET_CRYPTO_CURRENCY = 'user/SET_CRYPTO_CURRENCY'
export const CURRENCY_TO_CURRENCY = 'user/CURRENCY_TO_CURRENCY'
export const SET_INVITE_REFERRAL_CODE = 'user/SET_INVITE_REFERRAL_CODE'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js